import {
  AssetInternalCommentsControllerGetAssetCommentsParams,
  AssetVersionCommentDto
} from '@api/Api';
import { assetInternalCommentsGetAssetComments } from '@api/Asset';
import { getPlaceholderArrayQuery } from '@hooks/queries/helpers';
import { useQuery } from '@tanstack/react-query';

export const QUERY_COMMENTS_ASSETS = 'comments_assets';

export function useInternalCommentsAssetReviewQuery(
  params: AssetInternalCommentsControllerGetAssetCommentsParams,
  options?: {
    enabled?: boolean;
    keepPreviousData?: boolean;
    placeholderData?: AssetVersionCommentDto[];
  }
) {
  const queryKey = [QUERY_COMMENTS_ASSETS, params.assetVersionId];
  return useQuery({
    ...(options ?? {}),
    queryKey,
    queryFn: async ({ signal }) => {
      const { data } = await assetInternalCommentsGetAssetComments(params, {
        signal
      });
      return data.comments;
    },
    placeholderData: () => {
      if (options?.placeholderData) return options.placeholderData;
      const comments =
        getPlaceholderArrayQuery<AssetVersionCommentDto>(queryKey);
      if (!comments) return undefined;
      return comments;
    }
  });
}
